import React from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export const actualVolumeTooltip = {
    title: 'Actual Volume',
    body: (
        <span>
            is today&apos;s market traded volume, from open until now, expressed
            in shares. The volume bars are displayed in time bins, which can be
            changed in the chart configuration <Icon name="cog" />.
        </span>
    ),
};

export const expectedVolumeTooltip = {
    title: 'Expected Volume',
    body: (
        <span>
            is the market historical traded volume (averaged from the last 20
            days), expressed in shares. The volume bars are displayed in time
            bins, which can be changed in the chart configuration&nbsp;
            <Icon name="cog" />.
        </span>
    ),
};

export const lastBinActualTooltip = {
    body: 'Click To Toggle Last Bin Actual Volume Bar',
};

export const lastBinExpectedTooltip = {
    body: 'Click To Toggle Last Bin Expected Volume Bar',
};
